import { NgModule, provideAppInitializer } from "@angular/core";
import { ThemeInitFactory } from "app/core/theme/theme-init-factory";
import { ThemeService } from "app/core/theme/theme.service";

@NgModule({
  imports: [],
  declarations: [],
  providers: [
    ThemeService,
    provideAppInitializer(() => {
      const initializerFn = ((): (() => Promise<void>) => ThemeInitFactory)();
      return initializerFn();
    }),
  ],
})
export class ThemeModule {}
